module.exports = __webpack_public_path__ + "slider-02.jpg?5de8e7cf66001f047f1ce1610caa96e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-02.jpg
// module id = 265
// module chunks = 0